import RefreshLocationCacheAction from './refreshLocationCache/PluginSetup.js';
import FindAsset from './findAsset/PluginSetup.js';
// import AssetPairingDetail from './assetPairing/PluginSetup.js'
// import EquipmentPairingDetail from './equipmentPairing/PluginSetup.js'

export default {
  install: molten => {
    FindAsset.install(molten);
    RefreshLocationCacheAction.install(molten);
    // AssetPairingDetail.install( molten )
    // EquipmentPairingDetail.install( molten )
  }
};